<template>
  <div class="flex scale">
    <div v-for="index in guideData" :key="index.id" class="scale-button-container flex flex-column align-center">
      <div class="scale-button flex" @click="sendAnswer(index.id)" :class="{'selected': active == index.id, 'small-button': activeSector.id > 6}">
        <div>{{ index.description }}</div>
      </div>
      <div class="scale-button-description" v-if="false">{{buttonText(index)}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Scale',
  data() {
    return {
      active: null
    }
  },
  props: {
    num: {
      type: Number,
      reqired: true
    },
    answer: {
      type: Number
    }
  },
  computed: {
    activeSector() {
      return this.$store.getters.activeSector
    },
    guideData() {
      if (this.activeSector) {
        if (this.activeSector.id === 1) {
          return [
            {
              id: 1,
              title: 'Strongly disagree',
              description: 'I complete assigned tasks but rarely take initiative or ownership.'
            },
            {
              id: 2,
              title: 'Disagree',
              description: 'I occasionally take initiative but often need guidance.'
            },
            {
              id: 3,
              title: 'Neither agree nor disagree',
              description: 'I regularly take ownership of my tasks and contribute ideas.'
            },
            {
              id: 4,
              title: 'Agree',
              description: 'I frequently take initiative, propose new ideas, and own projects.'
            },
            {
              id: 5,
              title: 'Strongly Agree',
              description: 'I consistently take full ownership, innovate, and pursue new opportunities proactively.'
            }
          ]
        }

        if (this.activeSector.id === 2) {
          return [
            {
              id: 1,
              title: 'Strongly disagree',
              description: 'I sometimes consider feedback or learning opportunities, though I may need extra encouragement to act on them.'
            },
            {
              id: 2,
              title: 'Disagree',
              description: 'I occasionally seek feedback or learning opportunities, but I may hesitate to implement them immediately.'
            },
            {
              id: 3,
              title: 'Neither agree nor disagree',
              description: 'I regularly seek feedback and apply it to improve my performance and knowledge.'
            },
            {
              id: 4,
              title: 'Agree',
              description: 'I frequently seek feedback and actively apply it to enhance my skills and adapt to changes.'
            },
            {
              id: 5,
              title: 'Strongly Agree',
              description: 'I always seek out feedback and learning opportunities, and I consistently use them to improve my performance.'
            }
          ]
        }

        if (this.activeSector.id === 3) {
          return [
            {
              id: 1,
              title: 'Strongly disagree',
              description: 'I sometimes contribute to team efforts, though I may prefer to focus on individual tasks.'
            },
            {
              id: 2,
              title: 'Disagree',
              description: 'I occasionally collaborate with others and offer support, but I may wait for opportunities to arise.'
            },
            {
              id: 3,
              title: 'Neither agree nor disagree',
              description: 'I regularly collaborate with my team and offer support when needed.'
            },
            {
              id: 4,
              title: 'Agree',
              description: 'I frequently take the initiative to collaborate with others and provide support to my colleagues.'
            },
            {
              id: 5,
              title: 'Strongly Agree',
              description: 'I always actively collaborate and offer support to my team, ensuring we achieve our goals together.'
            }
          ]
        }

        if (this.activeSector.id === 4) {
          return [
            {
              id: 1,
              title: 'Strongly disagree',
              description: 'I sometimes take responsibility but struggle to be fully transparent, especially when addressing mistakes.'
            },
            {
              id: 2,
              title: 'Disagree',
              description: 'I occasionally show transparency but may withhold information or avoid difficult topics in challenging situations.'
            },
            {
              id: 3,
              title: 'Neither agree nor disagree',
              description: 'I regularly communicate with transparency while respecting the need for confidentiality in appropriate situations.'
            },
            {
              id: 4,
              title: 'Agree',
              description: 'I frequently make ethical decisions, demonstrating transparency, respect, and maintaining confidentiality under pressure.'
            },
            {
              id: 5,
              title: 'Strongly Agree',
              description: 'I consistently uphold high standards of responsibility, transparency, respect, and confidentiality.'
            }
          ]
        }

        if (this.activeSector.id === 5) {
          return [
            {
              id: 1,
              title: 'Strongly disagree',
              description: 'I sometimes take ownership for my tasks and commitments, but I may miss deadlines or require support to stay on track.'
            },
            {
              id: 2,
              title: 'Disagree',
              description: 'I occasionally take ownership of tasks and meet my commitments, but sometimes need extra time or assistance to ensure completion.'
            },
            {
              id: 3,
              title: 'Neither agree nor disagree',
              description: 'I regularly take ownership of my tasks, meeting commitments on time and ensuring my work is completed to a good standard.'
            },
            {
              id: 4,
              title: 'Agree',
              description: 'I frequently take full ownership of tasks and deliver on commitments, often exceeding expectations by completing work ahead of schedule.'
            },
            {
              id: 5,
              title: 'Strongly Agree',
              description: 'I consistently take full ownership of my responsibilities, delivering high-quality work on time and proactively meeting or exceeding expectations.'
            }
          ]
        }

        if (this.activeSector.id === 6) {
          return [
            {
              id: 1,
              title: 'Strongly disagree',
              description: 'I sometimes support my team, though I may not consistently prioritize guidance or development opportunities.'
            },
            {
              id: 2,
              title: 'Disagree',
              description: 'I occasionally offer direction and development, though I could be more proactive in coaching and feedback.'
            },
            {
              id: 3,
              title: 'Neither agree nor disagree',
              description: 'I regularly guide my team, encouraging growth, collaboration, and effective communication.'
            },
            {
              id: 4,
              title: 'Agree',
              description: 'I frequently provide clear direction and foster a positive, collaborative, and growth-oriented environment.'
            },
            {
              id: 5,
              title: 'Strongly Agree',
              description: 'I consistently lead by example, promoting learning, resolving conflicts, and tailoring support to my team’s needs.'
            }
          ]
        }

        return [
            {
              id: 1,
              title: 'Strongly disagree',
              description: 'Rarely'
            },
            {
              id: 2,
              title: 'Disagree',
              description: 'Occassionally'
            },
            {
              id: 3,
              title: 'Neither agree nor disagree',
              description: 'Regularly'
            },
            {
              id: 4,
              title: 'Agree',
              description: 'Frequently'
            },
            {
              id: 5,
              title: 'Strongly Agree',
              description: 'Consistently'
            }
          ]
      }
    }
  },
  methods: {
    sendAnswer(val) {
      this.active = val
      this.$emit('sendAnswer', val)
    },
    buttonText(index) {
      switch (index) {
        case 1:
          return 'Strongly disagree'
          break;
        case 2:
          return 'Disagree'
          break;
        case 3:
          return 'Neither agree nor disagree'
          break;
        case 4:
          return 'Agree'
          break;  
        default:
          return 'Strongly Agree'
          break;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .scale {
    margin: 20px;
    gap: 10px;
    .scale-button-container {
      width: 20%;
      max-width: 100%;
      align-self: stretch;
    }
    .small-button {
      width: 75%;
    }
    .scale-button {
      padding: 20px;
      height: 100%;
      text-align: center;
      background: #F4F4FC;
      border-radius: 8px;
      justify-content: center;
      align-items: center;
      font-weight: 500;
      font-size: 16px;
      cursor: pointer;
    }
    .scale-button-description {
      margin-top: 5px;
      width: 60px;
      text-align: center;
      font-size: 12px;
      font-weight: 700;
      color: #a1a2a8
    }
    .selected {
      background: #0E52E9;
      font-weight: 700;
      color: white

    }
  }
</style>
